import { render, staticRenderFns } from "./AforoEditar.vue?vue&type=template&id=310cd814&scoped=true"
import script from "./AforoEditar.vue?vue&type=script&lang=js"
export * from "./AforoEditar.vue?vue&type=script&lang=js"
import style0 from "./AforoEditar.vue?vue&type=style&index=0&id=310cd814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310cd814",
  null
  
)

export default component.exports